module.exports = __webpack_public_path__ + "static/media/16UNODC22.a108d3f3.jpg";